import styled from "styled-components";

const DropdownMenuDivider = styled("hr")`
  border: none;
  border-top: 1px solid #e5eaef;
`;

export default DropdownMenuDivider;
